import apiWorker from '../apiWorker'

const events = {
    find : (company_id, query) => apiWorker('get', `/v1/admin/${company_id}/events${query}`),
}

export default events;